export default __webpack_public_path__ + "static/media/services-icon.5811578d.svg";